import Jarvis from "./Jarvis";
import Analytics from "./Analytics";

var appState = {
  env: getEnvironment(),
  locale: $("html").attr("lang"),
  userId: "",
};
var jarvis = new Jarvis();
var analytics = new Analytics(appState);

// method that returns the environment of the page
function getEnvironment() {
  if (
    window.location.origin.indexOf("www.nvidia") !== -1 ||
    window.location.origin.indexOf("author.nvidia") !== -1 ||
    window.location.origin.indexOf("preview.nvidia") !== -1
  ) {
    return "p";
  } else if (
    window.location.origin.indexOf("wwwstage.nvidia") !== -1 ||
    window.location.origin.indexOf("authorstage.nvidia") !== -1
  ) {
    return "s";
  } else if (
    window.location.origin.indexOf("wwwdev.nvidia") !== -1 ||
    window.location.origin.indexOf("authordev.nvidia") !== -1
  ) {
    return "d";
  } else if (
    window.location.origin.indexOf("wwwqa.nvidia") !== -1 ||
    window.location.origin.indexOf("authorqa.nvidia") !== -1
  ) {
    return "q";
  } else {
    return "l";
  }
}

function updateState(
  userData,
  eventData = {
    eventName: "gfeReleaseHighlights",
    page: "GFE_Release_Highlights",
  }
) {
  appState.userId = userData.userId + "";
  const { jTK, uCst, sfUid, ...restOfPayload } = appState.jsoAugmentedParam;
  restOfPayload.dIDa = restOfPayload.dIDa.join(",");
  if (appState.userId) {
    analytics.sendEventData(eventData.eventName, {
      page: eventData.page,
      status: "Success",
      errorDetails: "",
      ...restOfPayload,
    });
  }
}

function init() {
  try {
    var passedParam = JSON.parse(
      decodeURI(window.atob(NVIDIAGDC.Browser.getUrlParameter("jso")))
    );
    appState.delegateToken = passedParam.jTK;
    appState.consent = passedParam.uCst[2];
    appState.jsoAugmentedParam = passedParam;
    appState.starfleetId = passedParam.sfUid;
  } catch (err) {
    appState.delegateToken = "";
    appState.consent = "0";
  }
  // only send the events when we have a delegate/starfleet id and the user consented to behavioral tracking
  if (appState.delegateToken && appState.consent === "1") {
    jarvis.redeemDelegate(appState.delegateToken, appState).always(updateState);
  } else if (appState.starfleetId && appState.consent === "1") {
    updateState(
      { userId: appState.starfleetId },
      { eventName: "nvappReleaseHighlights", page: "NVAPP_Release_Highlights" }
    );
  }
}

$(window).on("load", function () {
  init();
});
